import { COMPANY_EMAIL } from './COMPANY_EMAIL';
import { COMPANY_PHONE } from './COMPANY_PHONE';
import { COMPANY_PHONE_UNFORMATTED } from './COMPANY_PHONE_UNFORMATTED';
/**
 * @group Contact
 * @summary Contact methods
 * 
 * @remarks
 * This constant contains the primary contact methods for the company,
 * including email and phone links for direct communication.
 * 
 * @example
 * ```typescript
 * import { CONTACT_METHODS } from '@shared/constants';
 * 
 * CONTACT_METHODS.forEach(method => {
 *   const contactLink = document.createElement('a');
 *   contactLink.href = method.href;
 *   contactLink.textContent = method.label;
 *   contactSection.appendChild(contactLink);
 * });
 * ```
 */
export const CONTACT_METHODS = [
  {
    href: `mailto:${COMPANY_EMAIL}`,
    label: COMPANY_EMAIL
  },
  {
    href: `tel:${COMPANY_PHONE_UNFORMATTED}`,
    label: COMPANY_PHONE
  }
] as const; 